import React from "react"
import { Link } from "gatsby"
import {default as SeoComponent} from "../../components/seo"
import SharePanel from "../../components/share"
import SearchLogo from '../../fonts/search.svg'
const { useState } = React;

const AuthorsArchive = props => {
    const {
        pageContext: { users },
    } = props

    users.sort(function(a, b){
        if(a.name < b.name) { return -1; }
        if(a.name > b.name) { return 1; }
        return 0;
    })

    const [_users, setObjectList] = useState(users || [])

    const [searchQ, setValue] = useState('');
    const handleChange = (e) => {
        const _searchQ = e.target.value;
        setValue(_searchQ);

        setObjectList(users.filter(
        (user) => {
            return user['name'].toLowerCase().indexOf((_searchQ || '').toLowerCase()) !== -1
        }));
    };

  return (
    <div className="authors" style={{paddingTop: '3rem', paddingBottom: '3rem'}}>
      <SeoComponent
        title={'I nostri autori'}
        description={'Bassa risoluzione per comprendere la contemporaneità'}
      />
      <div style={{display: 'flex'}}>
        <img style={{
          margin: 'auto',
          verticalAlign: 'middle',
          objectFit: 'contain',
          objectPosition: 'left',
          height: 'auto',
          maxHeight: '100px',
          display: 'inline-block',
        }} src={"/img/logo-startupitalia-rocket-red.png"} alt={"Home"}/>
      </div>

      <h2 className="textinitial mag_customnumcat_posts_title" style={{
        textAlign: 'center',
        height: '40px'
      }}>
        {'I nostri autori'}
      </h2>
      <div
        style={{textAlign: 'center', marginBottom: '3rem'}}
      >Bassa risoluzione per comprendere la contemporaneità</div>

      <div style={{display: 'flex', paddingLeft: '1rem', marginBottom: '3rem', justifyContent: 'center'}}>
        <input
          type="text"
          value={searchQ}
          onChange={handleChange}
          // onKeyDown={(e) => { if (e.key === 'Enter') this.handleKeyDown(e) }}
          // disabled={(this.state.isLoading)?"disabled":""}
        />
        <button
          name="searchQ"
          id="searchQ"
          // onClick={this.handleClick}
          // disabled={(this.state.isLoading)?"disabled":""}
          style={{background: 'transparent'}}
          >
            <img src={SearchLogo} style={{flex: 1}} alt={"Search"}/>
        </button>
      </div>

      <div style={{marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', justifyContent: 'center'}}>
        {_users.map(user => {
            return <div key={user.name + user.slug}>
              <Link to={`/author/${user?.slug? user?.slug: ""}`}>
                <div style={{
                      boxSizing: 'border-box',
                      border: '1px solid #C2D1D9',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      margin: '0.2rem'
                    }}
                    className="author-card"
                    src={user.avatar.url}
                    alt=""
                  >
                    <div
                      style={{
                        marginTop: '1rem',
                        backgroundSize: "cover",
                        backgroundImage: "url(" + ((user.avatar.url || '').includes('secure.gravatar.com') ? '/img/logo-startupitalia-rocket2x.png' : user.avatar.url) + ")",
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center center',
                      }}
                      className="author-card-img"
                    ></div>
                    <div
                      style={{
                        marginTop: '1.5rem',
                        height: '12px',
                        width: '125px',
                        fontFamily: "urw-din",
                        color: '#232323',
                        letterSpacing: '0.48px',
                        lineHeight: '12px',
                        textAlign: 'center',
                        fontWeight: 'bold',
                      }}
                      className="author-card-name"
                    >{user.name}</div>
                </div>
              </Link>
            </div>
          })}
          <SharePanel display="none"/>
      </div>
    </div>
  )
}

export default AuthorsArchive
